import { Closable } from "../modal/closable";
import { closeSymbol } from "../modal/symbols";

export const instanceSymbol = Symbol("setInstanceSymbol");

export class SnackbarRef<T = any> {
	private componentInstance: T;

	constructor(private service: Closable) {}

	set [instanceSymbol](instance: T) {
		this.componentInstance = instance;
	}

	get instance() {
		return this.componentInstance;
	}

	close() {
		this.service[closeSymbol]();
	}
}
